import { render, staticRenderFns } from "./caseManage.vue?vue&type=template&id=011c2852&scoped=true&"
import script from "./caseManage.vue?vue&type=script&lang=js&"
export * from "./caseManage.vue?vue&type=script&lang=js&"
import style0 from "./caseManage.vue?vue&type=style&index=0&id=011c2852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c2852",
  null
  
)

export default component.exports